var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcAnnouncementOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.07,
    cx: 21.375,
    cy: 21,
    r: 21,
    fill: "#9A84F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6199 19.3033L21.8196 11.5019C21.3596 11.043 20.6154 11.0484 20.1614 11.5013C19.7048 11.9591 19.7048 12.7024 20.1614 13.1595L27.9628 20.9605C28.4199 21.4175 29.1629 21.4175 29.6199 20.9605C30.0782 20.5022 30.0782 19.7616 29.6199 19.3033Z",
    fill: "#9A84F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5826 14.2383L19.5239 14.5326C19.1103 16.6013 18.1053 18.5665 16.7458 20.1594L20.9899 24.4034C22.5825 23.0443 24.5207 22.0122 26.5895 21.5981L26.8843 21.5394L19.5826 14.2383Z",
    fill: "#9A84F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9678 21.0383L13.0673 23.9383C12.3819 24.6236 12.3791 25.7363 13.0673 26.4245L14.7244 28.0816C15.4097 28.7669 16.5224 28.7697 17.2106 28.0816L20.1108 25.1813L15.9678 21.0383ZM16.3821 25.596C16.1532 25.8248 15.7824 25.8248 15.5535 25.596C15.3247 25.3671 15.3247 24.9963 15.5535 24.7674L16.3821 23.9388C16.6109 23.71 16.9818 23.71 17.2106 23.9388C17.4395 24.1677 17.4395 24.5385 17.2106 24.7674L16.3821 25.596Z",
    fill: "#9A84F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5573 28.3934L23.3544 27.5964C24.0426 26.9082 24.0404 25.7956 23.3544 25.1108L22.7624 24.5183C22.4352 24.7381 22.1227 24.9769 21.8188 25.2318L22.5259 25.9399C22.7542 26.167 22.7558 26.5367 22.5259 26.7679L21.7156 27.5781L20.5249 26.4245L18.8677 28.0816L21.5262 30.6577C21.9799 31.1126 22.7248 31.1151 23.1827 30.6571C23.6399 30.1999 23.6399 29.4567 23.1827 28.9994L22.5573 28.3934Z",
    fill: "#9A84F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9244 11C24.6005 11 24.3384 11.2621 24.3384 11.5859V12.7578C24.3384 13.0817 24.6005 13.3438 24.9244 13.3438C25.2482 13.3438 25.5103 13.0817 25.5103 12.7578V11.5859C25.5103 11.2621 25.2482 11 24.9244 11Z",
    fill: "#9A84F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6119 15.6875H28.4401C28.1162 15.6875 27.8541 15.9496 27.8541 16.2734C27.8541 16.5973 28.1162 16.8594 28.4401 16.8594H29.6119C29.9358 16.8594 30.1979 16.5973 30.1979 16.2734C30.1979 15.9496 29.9358 15.6875 29.6119 15.6875Z",
    fill: "#9A84F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8543 12.3433C28.6254 12.1144 28.2546 12.1144 28.0257 12.3433L26.8538 13.5152C26.625 13.744 26.625 14.1148 26.8538 14.3437C27.0827 14.5726 27.4535 14.5726 27.6824 14.3437L28.8543 13.1718C29.0831 12.943 29.0831 12.5721 28.8543 12.3433Z",
    fill: "#9A84F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnnouncementOrder);
export default __webpack_public_path__ + "static/media/ic_announcement_order.4e069c86e22abef4f2ead512f11c297d.svg";
export { ForwardRef as ReactComponent };